import { capitalize, pxToRem } from './utils.mjs'
/**
 * @enum {number}
 */
export const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1440,
  '3xl': 1920
}

export const colors = {
  black: '#000',
  blue: '#00F',
  green: '#75F348',
  grey: '#9A9EAC',
  'grey-dark': '#3E3F45',
  'grey-darker': '#2E2F34',
  red: '#F00',
  white: '#FFF'
}

const breakpointsEntries = Object.entries(breakpoints)
/**
 * @typedef {{[k in keyof typeof breakpoints as `at${Capitalize<k>}`]: {min?: string, max?: string}}} OnlyValues
 * @typedef {{[k in keyof typeof breakpoints as `lt${Capitalize<k>}`]: {min?: string, max?: string}}} BeforeValues
 * @typedef {{[k in keyof typeof breakpoints]: string}} Values
 *
 * @typedef {OnlyValues & BeforeValues & Values} Breakpoints
 *
 * @type {Breakpoints}
 */
// @ts-ignore
export const screens = breakpointsEntries.reduce((acc, [name, value], i) => {
  const nextBreakpoint = breakpointsEntries[i + 1]
  acc[name] = pxToRem(value)
  acc[`at${capitalize(name)}`] = nextBreakpoint
    ? { min: pxToRem(value), max: pxToRem(nextBreakpoint[1] - 1) }
    : { min: pxToRem(value) }

  acc[`lt${capitalize(name)}`] = { max: pxToRem(value - 1) }
  return acc
}, {})

export default {
  breakpoints: breakpointsEntries.reduce((acc, [name, value], i) => {
    acc[name] = pxToRem(value)
    return acc
  }, {}),
  colors
}
